import addToTotalTranTypeArr from "./add_to_total_tran_type_arr";

export const calculateSavingsTotalByTranType = (savingsArr, savingsClass, tranSort, savingTranArr,
    currentPriceArr) => {

    let totalByTranTypeArr = [];
    for (let i=0; i<savingsArr.length; i++ ){
        if (savingsArr[i].savingsClass === savingsClass){
            const savingsType = savingsArr[i].savingsType;
            let currentPrice = 0;
            if (savingsClass === "retirement" && currentPriceArr){
                const currentPriceObj = 
                        currentPriceArr.find(elem => elem.retirementType === savingsType);
                currentPrice = currentPriceObj.currentPrice;
            }
            let tranArr = [];
            if (savingTranArr.length > 0){
                tranArr = JSON.parse(JSON.stringify(
                    savingTranArr.find(elem => elem.savingsType === savingsType).savingTranArr));
            }
            
            for (let j=0; j<tranArr.length; j++){
                const tranArrObj = tranArr[j];
                const tranYear = tranArrObj.tranDate.split('-')[0];
                addToTotalTranTypeArr(savingsType, savingsClass, tranYear, currentPrice, 
                    tranArrObj, tranSort, totalByTranTypeArr );
                addToTotalTranTypeArr("all", savingsClass, tranYear, currentPrice, 
                    tranArrObj, tranSort, totalByTranTypeArr );
                addToTotalTranTypeArr("all", savingsClass, "all", currentPrice, 
                    tranArrObj, tranSort, totalByTranTypeArr );
            }
        }
    }
    return totalByTranTypeArr;
}
export default calculateSavingsTotalByTranType;